import magnificPopup from '../../js/jquery.magnific-popup.min.js?raw';
import {injectLegacyScript} from './inject-legacy-script';

export function ensureMagnificPopupPlugin()
{
    if (!window.jQuery || window.jQuery.fn.magnificPopup) {
        return;
    }

    injectLegacyScript(magnificPopup);
}

export function initBannerImagePopup(selector)
{
    if (!window.jQuery) {
        return;
    }

    ensureMagnificPopupPlugin();

    var $ = window.jQuery;

    $(window).on('load', function () {
        var $bannerImages = $(selector || '.chaletBanner .slides .slidercontent .imageOpen');

        if (!$bannerImages.length || !$.fn.magnificPopup) {
            return;
        }

        $bannerImages.magnificPopup({
            type: 'image',
            gallery: {enabled: true},
            callbacks: {
                imageLoadComplete: function () {
                    $('.mfp-img').mousedown(function () {
                        return false;
                    });
                    $('.mfp-figure').on('contextmenu', 'img', function () {
                        return false;
                    });
                },
            },
        });
    });
}

export function initIframePopup(selector)
{
    if (!window.jQuery) {
        return;
    }

    ensureMagnificPopupPlugin();

    var $ = window.jQuery;
    var $links = $(selector || '.mfp-link');

    if (!$links.length || !$.fn.magnificPopup) {
        return;
    }

    $links.magnificPopup({
        type: 'iframe',
        tClose: 'Close (Esc)',
        disableOn: 0,
        preloader: true,
        closeOnContentClick: false,
        closeOnBgClick: true,
        closeBtnInside: true,
        showCloseBtn: true,
        enableEscapeKey: true,
        fixedContentPos: 'auto',
        fixedBgPos: 'auto',
        overflowY: 'auto',
        closeMarkup: '<button type="button" title="%title%" class="mfp-close"><i class="mfp-close-icn">&times;</i></button>',
    });
}
